// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CoachingRouteImport } from './routes/coaching'
import { Route as CallRouteImport } from './routes/call'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResourcesSlugRouteImport } from './routes/resources_.$slug'
import { Route as GuidesSlugRouteImport } from './routes/guides_.$slug'

const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CoachingRoute = CoachingRouteImport.update({
            id: '/coaching',path: '/coaching',getParentRoute: () => rootRouteImport
          })
const CallRoute = CallRouteImport.update({
            id: '/call',path: '/call',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources_/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides_/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CallRoute: CallRoute,CoachingRoute: CoachingRoute,CookiesRoute: CookiesRoute,FeedbackRoute: FeedbackRoute,GuidesRoute: GuidesRoute,PrivacyRoute: PrivacyRoute,ResourcesRoute: ResourcesRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,GuidesSlugRoute: GuidesSlugRoute,ResourcesSlugRoute: ResourcesSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)